const pageNameKey = "findAutoMatchBlueprint";

export const findAutoMatchBlueprintEn = {
  [pageNameKey]: {
    subTitle: "Choose from suggested verified Blueprints",
    blueprint: "Blueprint",
    blueprintLibrary: "Blueprint Library",
    applyButton: "Apply Blueprint",
    cancelButton: "Cancel",
    blueprintSupportText: "Didn't find the right blueprint?",
    blueprintSupportLink: "Ask us for support",
  },
};

export const findAutoMatchBlueprintPtBr = {
  [pageNameKey]: {
    subTitle: "Escolha entre os Blueprints verificados sugeridos",
    blueprint: "Projeto",
    blueprintLibrary: "Biblioteca de blueprints",
    applyButton: "Aplicar modelo",
    cancelButton: "Cancelar",
    blueprintSupportText: "Não encontrou o blueprint certo?",
    blueprintSupportLink: "Peça suporte à nossa equipe",
  },
};

export const findAutoMatchBlueprintDe = {
  [pageNameKey]: {
    subTitle: "Aus den vorgeschlagenen verifizierten Blueprints wählen",
    blueprint: "Blueprint",
    blueprintLibrary: "Blueprint-Bibliothek",
    applyButton: "Blueprint anwenden",
    cancelButton: "Abbrechen",
    blueprintSupportText: "Den richtigen Blueprint nicht gefunden?",
    blueprintSupportLink: "Kontaktieren Sie uns",
  },
};

export const findAutoMatchBlueprintZhHans = {
  [pageNameKey]: {
    subTitle: "从建议的验证蓝图中选择",
    blueprint: "蓝图",
    blueprintLibrary: "蓝图库",
    applyButton: "应用蓝图",
    cancelButton: "取消",
    blueprintSupportText: "没有找到合适的蓝图？",
    blueprintSupportLink: "联系我们获取支持",
  },
};

export const findAutoMatchBlueprintIt = {
  [pageNameKey]: {
    subTitle: "Scegli tra i Blueprint suggeriti e verificati",
    blueprint: "Blueprint",
    blueprintLibrary: "Libreria di Blueprint",
    applyButton: "Applica Blueprint",
    cancelButton: "Annulla",
    blueprintSupportText: "Non hai trovato il Blueprint giusto?",
    blueprintSupportLink: "Richiedi supporto",
  },
};

export const findAutoMatchBlueprintEs = {
  [pageNameKey]: {
    subTitle: "Elige entre los planos verificados sugeridos",
    blueprint: "Plano",
    blueprintLibrary: "Biblioteca de planos",
    applyButton: "Aplicar plano",
    cancelButton: "Cancelar",
    blueprintSupportText: "¿No encontraste el plano adecuado?",
    blueprintSupportLink: "Pídenos ayuda",
  },
};

export const findAutoMatchBlueprintNl = {
  [pageNameKey]: {
    applyButton: "Blueprint toepassen",
    blueprint: "Blueprint",
    blueprintLibrary: "Blueprint-bibliotheek",
    blueprintSupportText: "Niet de juiste blueprint gevonden?",
    cancelButton: "Annuleren",
    subTitle: "Kies uit voorgestelde geverifieerde blueprints",
    blueprintSupportLink: "Vraag ons om ondersteuning",
  },
};

export const findAutoMatchBlueprintTr = {
  [pageNameKey]: {
    applyButton: "Planı Uygula",
    blueprint: "Taslak",
    blueprintLibrary: "Plan Kitaplığı",
    blueprintSupportLink: "Bizden destek isteyin",
    blueprintSupportText: "Doğru planı bulamadınız mı?",
    cancelButton: "İptal etmek",
    subTitle: "Önerilen doğrulanmış Planlar arasından seçim yapın",
  },
};
